import type { VModelEvents } from '../hooks/use-v-model';
import { createEmits } from '../utils/emits';

// Checkbox 的事件类型
interface CheckboxEvents extends VModelEvents<boolean> {
  change: [checked: boolean, context: { e: Event }];
}

// CheckboxGroup 的事件类型
interface CheckboxGroupEvents extends VModelEvents<Array<string | number | boolean>> {
  change: [value: Array<string | number | boolean>, context: { e: Event }];
}

const checkboxEmitsCreator = createEmits<CheckboxEvents>();
const checkboxGroupEmitsCreator = createEmits<CheckboxGroupEvents>();

export const useCheckboxEmits = checkboxEmitsCreator.useEmits;
export const useCheckboxGroupEmits = checkboxGroupEmitsCreator.useEmits;

/**
 * 组件的emit事件声明
 */
export const emits = [
  /** Vue2 的 v-model 事件 */
  'input',
  /** Vue3 的 v-model 事件 */
  'update:modelValue',
  /** 选中状态变化时触发 */
  'change',
];

